import 'normalize.css'
import './assets/css/default.css'

import checkCompatibility from './compatibility'

if (checkCompatibility()) {
  console.debug('Compatibility checking: SUCCESS')
  require('./app.js')
  require('./maintenance.js')
} else {
  console.error('Compatibility checking: FAILURE')
  document.getElementById('noscript').style.display = 'block'
  document.getElementById('app').style.display = 'none'
}



// WEBPACK FOOTER //
// ./src/app/index.js